// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"az_Hv","question":"az_Iv"};